module.exports = __webpack_public_path__ + "static/media/noun-trip-brochure-5074158-142350-cropped.b37afa5c.svg";